import { ApiErrorPageWithTrans } from '@components/Error/ApiErrorPageWithTrans';
import { ContentWrapperCustomerApp } from '@components/Layouts/ContentWrapperCustomerApp';
import { NoddiLoadingScreenWithTrans } from '@components/Loading/NoddiLoadingScreenWithTrans';
import { InviteFriendsCard } from '@components/Referrals/InviteFriendsCard';
import { ReferredFriendsSection } from '@components/Referrals/ReferredFriendsSection';
import { t } from '@lingui/core/macro';
import { Trans } from '@lingui/react/macro';
import { noddiAsync, URLKeys } from 'noddi-async';
import { NoddiBasicCard } from 'noddi-ui-web';
import { useAuthContext } from 'noddi-web';
import { useCurrentBrand } from '../../../stores/BrandStore/brandStore';

export const Referrals = () => {
  const { currentUserGroupId } = useAuthContext();
  const { currentBrand } = useCurrentBrand();

  const {
    isPending: isReferralPending,
    data: referral,
    error: referralError
  } = noddiAsync.useGet({
    type: URLKeys.getReferrals,
    input: { userGroupId: currentUserGroupId!, brandDomain: currentBrand },
    queryConfig: {
      enabled: !!currentUserGroupId
    }
  });

  const {
    isPending: isReferredFriendsPending,
    data: referredFriends,
    error: referredFriendsError
  } = noddiAsync.useGet({
    type: URLKeys.getReferredFriends,
    input: { userGroupId: currentUserGroupId!, brandDomain: currentBrand },
    queryConfig: {
      enabled: !!currentUserGroupId
    }
  });

  if (isReferralPending || isReferredFriendsPending) {
    return <NoddiLoadingScreenWithTrans />;
  }
  if (referralError) {
    return <ApiErrorPageWithTrans error={referralError} />;
  }
  if (referredFriendsError) {
    return <ApiErrorPageWithTrans error={referredFriendsError} />;
  }

  const hasReferralCode = referral.referralCode != null && referral.referralCode !== '';

  return (
    <ContentWrapperCustomerApp showNewBookingButton title={t`Invite friends`}>
      <div className='flex flex-col gap-4'>
        {hasReferralCode ? (
          <>
            <InviteFriendsCard referral={referral} />
            <ReferredFriendsSection referredFriends={referredFriends} />
          </>
        ) : (
          <NoddiBasicCard className='p-4'>
            <p className='text-sm text-muted-foreground'>
              <Trans>Referrals are not available right now.</Trans>
            </p>
          </NoddiBasicCard>
        )}
      </div>
    </ContentWrapperCustomerApp>
  );
};
